import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TooltipsModule } from 'ionic4-tooltips';
import { ComponentsModule } from '../components.module';
import { AddEntityPage } from './add-entity';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { AddEntityPageRoutingModule } from './add-entity-routing.module';

@NgModule({
  declarations: [AddEntityPage],
  exports: [AddEntityPage],
  imports: [IonicModule, CommonModule, ComponentsModule, AddEntityPageRoutingModule, TooltipsModule.forRoot()],
  providers: [Camera],
})
export class AddEntityPageModule {}
